import axios from "axios";
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../config/constants";
import { X } from "lucide-react";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(location.state?.message || "");
  const [fieldError, setFieldError] = useState({ email: "" });

  const handleSendResetLink = async () => {
    setError("");
    setSuccess("");
    setFieldError({ email: "" });

    if (!email) {
      setFieldError({ email: "Please enter your email" });
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setFieldError({ email: "Please enter a valid email address" });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API_BASE_URL}/forgot-password`, {
        email: email.toLowerCase(),
      });

      setSuccess("Password reset link has been sent to your email!");
      setEmail("");
    } catch (err) {
      const message =
        err.response?.data?.message ||
        "Failed to send reset link. Please try again.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-t from-custom-dark-image to-custom-green-image flex flex-col justify-center items-center px-4 py-8 overflow-hidden">
      {/* Success Message */}
      {success && (
        <div className="mb-6 max-w-md w-full">
          <div className="bg-green-100 border border-green-400 text-green-700 px-6 py-4 rounded-lg text-sm text-center font-medium">
            {success}
          </div>
        </div>
      )}

      {/* Error Alert */}
      {error && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 max-w-sm w-full px-4 z-50">
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg shadow-lg flex items-center justify-between text-sm">
            <div>
              <strong className="font-bold">Error! </strong>
              {error}
            </div>
            <button onClick={() => setError("")} className="text-red-700 hover:text-red-900">
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      )}

      {/* Forgot Password Card */}
      <div className="w-full max-w-[38rem] min-h-[40.875rem] bg-[#051E1C] backdrop-blur-sm rounded-2xl shadow-2xl px-[5.0625rem] py-[5.5rem]">
        <div className="flex mb-[4.125rem]">
          <img src="assets/kirloskar-logo.svg" alt="Logo" className="w-[16.6159rem] h-[3.125rem]" />
        </div>

        <h2 className="text-[2.25rem] font-poppins font-semibold text-white mb-[2.125rem]">
          Forgot Password
        </h2>


        <div>
          <label className="block text-[#D9D9D9] text-[1.125rem] font-medium mb-1.5">
            Email*
          </label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setFieldError({ email: "" });
            }}
            className={`w-[27.3125rem] h-[3.4375rem] py-[0.625rem] px-[0.875rem] bg-[#33504D75] text-white rounded-lg text-[1.125rem]
      ${fieldError.email
                ? "border border-red-500 focus:ring-red-500/40"
                : "focus:border-gray-300 focus:ring-teal-500/50"
              }`}
          />

          {/* Reserve space for error */}
          <p className={`mt-1 text-sm ${fieldError.email ? "text-red-500" : "text-transparent"}`}>
            {fieldError.email || "Placeholder"}
          </p>
        </div>

        <button
          onClick={handleSendResetLink}
          disabled={loading}
          className="w-[27.3125rem] bg-[#147A6F] h-[3.4375rem] text-white font-medium py-[0.625rem] px-[1.125rem] rounded-[6.25rem] text-[1.375rem] mt-[3.5625rem] mb-[2.8125rem]"
        >
          {loading ? "Sending Link..." : "Send Confirmation Link"}
        </button>

        <div className="text-center">
          <button
            onClick={() => navigate("/")}
            className="text-[#D9D9D9] text-[1.25rem] border-b border-[#D9D9D9] pb-[0.00001rem]"
          >
            Back to Login
          </button>


        </div>

      </div>
    </div>
  );
}